export default "__VITE_ASSET__CTSiR1kk__"